// SubscriptionRequired.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import "./SubscriptionRequired.css";

const SubscriptionRequired = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { currentUser, logout } = useAuth();
  const [userId, setUserId] = useState(null);
  const [isTrialExpired, setIsTrialExpired] = useState(false);

  useEffect(() => {
    const handleSubscriptionRequired = async () => {
      try {
        // Get state from navigation or localStorage
        const stateFromRedirect = location.state || {};
        const trialExpiredFlag =
          stateFromRedirect.trialExpired ||
          localStorage.getItem("trialExpired") === "true";

        setIsTrialExpired(trialExpiredFlag);

        // Get user ID from current user or from localStorage for expired trials
        let userIdToStore = null;
        if (currentUser) {
          userIdToStore = currentUser.uid;
          setUserId(userIdToStore);
        } else {
          // For expired trials, user might already be logged out
          const storedUserId = localStorage.getItem("expiredTrialUserId");
          if (storedUserId) {
            setUserId(storedUserId);
          }
        }

        // Clear any saved payment state
        localStorage.removeItem("paymentPending");
        localStorage.removeItem("stripeTempRef");
        sessionStorage.removeItem("authStartedWithPayment");

        // Clear trial expired flag after reading it
        localStorage.removeItem("trialExpired");

        // If user is still logged in, log them out
        if (currentUser) {
          try {
            await logout();
          } catch (logoutError) {}
        }
      } catch (error) {}
    };

    handleSubscriptionRequired();
  }, [location, currentUser, logout]);

  const handleBackToLogin = () => {
    // Clear the flag when going back to login
    localStorage.removeItem("trialAlreadyUsed");

    // Direct to login page now that auth has been cleared
    navigate("/login", { replace: true });
  };

  return (
    <div className="subscription-required-container">
      <div className="subscription-required-content">
        <img src="You_Create_Logo_WEB.png" alt="YouCreate Logo" />
        <h2>Subscription Required</h2>

        {isTrialExpired ? (
          <>
            <p>Your trial period has ended.</p>
            <p>
              To continue accessing your work and using YouCreate, please
              purchase a subscription.
            </p>
          </>
        ) : localStorage.getItem("trialAlreadyUsed") ? (
          <>
            <p>You've already used your free trial period.</p>
            <p>Please select a paid subscription to continue.</p>
          </>
        ) : (
          <>
            <p>To access YouCreate, you need an active subscription.</p>
            <p>Please purchase a subscription to continue.</p>
          </>
        )}
        <div className="subscription-buttons">
          <button
            onClick={() =>
              (window.location.href = "https://youcreate.app/trial-end/")
            }
          >
            Get Subscription
          </button>
          <button className="secondary-button" onClick={handleBackToLogin}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionRequired;
